if (window.membersAwardInitialized) {
  console.warn("Members Award JS already initialized");
} else {
  window.membersAwardInitialized = true;
  (async function () {
    const PER_PAGE = 5;
    const COLLECTION = "awards";
    const cardsContainer = document.getElementById("ma-cards");
    if (!cardsContainer) return;
    if (typeof envConfig === "undefined") return;
    const BASE_URL = `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}`;
    const API_KEY = envConfig.TYPESENSE_SEARCH_ONLY_KEY;

    // State
    let activeAwardTypes = new Set();
    let activeEligibility = new Set();
    let searchQuery = "";
    let debounceTimer = null;
    let currentPage = 1;
    let totalFound = 0;
    let renderedCount = 0;
    let isLoading = false;
    let filtersBuilt = false;

    // Maps lifted to outer scope
    let awardTypeMap = new Map();
    let eligibilityMap = new Map();

    function getURLParams() {
      const params = new URLSearchParams(window.location.search);
      return {
        q: params.get("ma_q") || "",
        types: params.get("ma_types")
          ? params.get("ma_types").split(",").filter(Boolean)
          : [],
        elig: params.get("ma_elig")
          ? params.get("ma_elig").split(",").filter(Boolean)
          : [],
      };
    }

    function updateURL() {
      const params = new URLSearchParams(window.location.search);

      if (searchQuery) params.set("ma_q", searchQuery);
      else params.delete("ma_q");

      if (activeAwardTypes.size)
        params.set("ma_types", [...activeAwardTypes].join(","));
      else params.delete("ma_types");

      if (activeEligibility.size)
        params.set("ma_elig", [...activeEligibility].join(","));
      else params.delete("ma_elig");

      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? "?" + newSearch : "") +
        window.location.hash;

      window.history.replaceState({}, "", newUrl);
    }
    // DOM refs
    const pagination = document.getElementById("ma-pagination");
    const loadMoreBtn = document.getElementById("ma-load-more");
    const showLessBtn = document.getElementById("ma-show-less");
    const section = document.getElementById("ma-section");
    const searchInput = document.getElementById("ma-search");
    const searchContainer = document.getElementById("ma-search-container");
    const resultsPanel = document.getElementById("ma-results-panel");
    const resultsCount = document.getElementById("ma-results-count");
    const chipsContainer = document.getElementById("ma-chips-container");
    const clearSearchBtn = document.getElementById("ma-clear-search");
    const closeIconUrl = resultsPanel?.dataset.closeIcon || "";

    searchContainer?.addEventListener("click", () => {
      searchInput?.focus();
    });

    function buildChip(label, onRemove) {
      const chip = document.createElement("span");
      chip.className =
        "w-auto flex items-center justify-between gap-[.625rem] p-2 !pl-[.625rem] md:!pl-[1.25rem] text-white text-p1 font-normal font-neutraface rounded-full bg-brand-dark-red";
      chip.innerHTML = `
        <span class="capitalize">${label}</span>
        <img src="${closeIconUrl}" alt="remove"
          class="w-[1.5625rem] h-[1.5625rem] object-contain object-center cursor-pointer flex-shrink-0">
      `;
      chip.querySelector("img").addEventListener("click", (e) => {
        e.preventDefault();
        onRemove();
      });
      return chip;
    }

    function updateResultsPanel() {
      const hasActivity =
        searchQuery.length > 0 ||
        activeAwardTypes.size > 0 ||
        activeEligibility.size > 0;

      if (!hasActivity) {
        resultsPanel.classList.add("hidden");
        resultsPanel.classList.remove("flex");
        return;
      }

      resultsPanel.classList.remove("hidden");
      resultsPanel.classList.add("flex");

      resultsCount.textContent = `${totalFound} Result${totalFound !== 1 ? "s" : ""}`;

      chipsContainer.innerHTML = "";

      if (searchQuery) {
        chipsContainer.appendChild(
          buildChip(searchQuery, () => {
            searchQuery = "";
            searchInput.value = "";
            triggerFilter();
            syncAllVisuals();
          }),
        );
      }

      activeAwardTypes.forEach((slug) => {
        const name = awardTypeMap.get(slug) || slug;
        chipsContainer.appendChild(
          buildChip(name, () => {
            activeAwardTypes.delete(slug);
            syncAllVisuals();
            triggerFilter();
          }),
        );
      });

      activeEligibility.forEach((slug) => {
        const name = eligibilityMap.get(slug) || slug;
        chipsContainer.appendChild(
          buildChip(name, () => {
            activeEligibility.delete(slug);
            syncAllVisuals();
            triggerFilter();
          }),
        );
      });
    }

    clearSearchBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      searchQuery = "";
      searchInput.value = "";
      activeAwardTypes.clear();
      activeEligibility.clear();
      syncAllVisuals();
      triggerFilter();
    });

    function buildFilterBy() {
      const parts = [];
      if (activeAwardTypes.size > 0)
        parts.push(`award_type_slugs:=[${[...activeAwardTypes].join(",")}]`);
      if (activeEligibility.size > 0)
        parts.push(`eligibility_slugs:=[${[...activeEligibility].join(",")}]`);
      return parts.join(" && ");
    }

    async function fetchPage(page) {
      const params = {
        q: searchQuery || "*",
        query_by: "title,description,searchable_text",
        sort_by: "title:asc",
        per_page: PER_PAGE,
        prefix: false,
        num_typos: 0,
        drop_tokens_threshold: 0,
        typo_tokens_threshold: 0,
        page,
      };

      const filterBy = buildFilterBy();
      if (filterBy) params.filter_by = filterBy;

      const url =
        `${BASE_URL}/collections/${COLLECTION}/documents/search?` +
        new URLSearchParams(params);
      const res = await fetch(url, {
        headers: {
          "X-TYPESENSE-API-KEY": API_KEY,
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    }

    function formatDeadline(timestamp) {
      if (!timestamp) return null;
      return new Date(timestamp * 1000).toLocaleDateString("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
      });
    }

    function buildApplyLink(postUrl) {
      if (!postUrl) return "";
      const template = document.getElementById("ma-link-template");
      if (!template) return "";
      const cleanUrl = postUrl.replace(/\/$/, "");
      const fullApplyUrl = cleanUrl + "/overview";
      return template.innerHTML
        .replace("__LINK_URL__", fullApplyUrl)
        .replace("__LINK_TITLE__", "Apply for Award");
    }

    function renderCards(docs, append = false) {
      if (!append) cardsContainer.innerHTML = "";

      if (!docs.length && !append) {
        cardsContainer.innerHTML = `<p class="w-full text-center py-12 text-brand-black opacity-60">No awards found.</p>`;
        pagination.classList.add("hidden");
        return;
      }

      docs.forEach((doc) => {
        const awardTypeBadges = doc.award_type_names?.length
          ? `<div class="w-full lg:w-auto lg:max-w-[16.25rem]">
              <div class="flex items-center md:items-start justify-center md:justify-start lg:justify-end gap-2 flex-wrap h-max">
                  ${doc.award_type_names
                    .map(
                      (name) => `
                    <span class="md:flex-shrink-0 pb-[.0625rem] pt-[.125rem] px-[.375rem] rounded bg-brand-light-blue text-[.8125rem] leading-[1.375rem] tracking-[.0406rem] uppercase text-brand-dark-blue">
                      ${name}
                    </span>`,
                    )
                    .join("")}
                </div>
              </div>`
          : "";

        const deadline = formatDeadline(doc.deadline_date);
        const deadlineHtml = deadline
          ? `<p class="text-brand-black text-p1 font-semibold text-center sm:text-start !my-0">Deadline: ${deadline}</p>`
          : "";

        const honoreeHtml = doc.eligibility_names?.length
          ? `<p class="text-brand-black text-p1 font-semibold text-center sm:text-start !my-0">
               Honoree: ${doc.eligibility_names.join(", ")}
             </p>`
          : "";

        const applyLink = buildApplyLink(doc.permalink);
        const hasBottom = deadlineHtml || honoreeHtml || applyLink !== "";

        let bottomSection = "";
        if (hasBottom) {
          const leftColumn =
            deadlineHtml || honoreeHtml
              ? `<div class="flex flex-col items-center md:items-start gap-[.0625rem]">
                   ${deadlineHtml}${honoreeHtml}
                 </div>`
              : "";

          bottomSection = `
            <div class="w-full grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4">
              <div class="lg:w-auto">${leftColumn}</div>
              <div class="lg:w-auto lg:max-w-[16.25rem]">${applyLink}</div>
            </div>`;
        }

        const card = document.createElement("a");
        card.href =
          (doc.permalink || "").replace(/\/$/, "") + "/overview" || "#";
        card.className =
          "w-full py-3 md:py-6 flex flex-col items-center justify-between gap-3 md:gap-6 border-b border-brand-warm-gray transform transition-transform duration-300 ease-in-out hover:scale-[1.01]";

        card.innerHTML = `
          <div class="w-full grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4">
            <div class="w-full lg:w-auto flex flex-col items-center md:items-start justify-between gap-2">
              ${doc.title ? `<h3 class="w-full lg:w-auto text-[1.5625rem] leading-[2.0625rem] text-brand-dark-blue font-semibold text-center md:text-start !my-0">${doc.title}</h3>` : ""}
              ${doc.description && doc.description.trim() ? `<div class="htmlBlock text-brand-black htmlBlock-para-style">${doc.description}</div>` : ""}
            </div>
            ${awardTypeBadges}
          </div>
          ${bottomSection}
        `;

        cardsContainer.appendChild(card);
      });
    }

    function updatePagination() {
      const allLoaded = renderedCount >= totalFound;
      if (totalFound <= PER_PAGE) {
        pagination.classList.add("hidden");
        return;
      }
      pagination.classList.remove("hidden");
      loadMoreBtn.classList.toggle("hidden", allLoaded);
      showLessBtn.classList.toggle("hidden", !allLoaded);
    }

    async function loadFresh(scroll = false) {
      if (isLoading) return;
      isLoading = true;

      cardsContainer.innerHTML = `
        <div class="w-full min-h-[7.5rem] flex items-center justify-center">
          <div class="flex flex-col items-center gap-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24">
              <g stroke="#C8102E" stroke-width="1">
                <circle cx="12" cy="12" r="9.5" fill="none" stroke-linecap="round" stroke-width="3">
                  <animate attributeName="stroke-dasharray" calcMode="spline" dur="1.5s" values="0 150;42 150;42 150;42 150" repeatCount="indefinite"/>
                  <animate attributeName="stroke-dashoffset" calcMode="spline" dur="1.5s" values="0;-16;-59;-59" repeatCount="indefinite"/>
                </circle>
                <animateTransform attributeName="transform" dur="2s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/>
              </g>
            </svg>
            <span class="text-brand-black font-neutraface text-[1.25rem] font-normal">Loading Awards...</span>
          </div>
        </div>`;

      pagination.classList.add("hidden");

      try {
        currentPage = 1;
        renderedCount = 0;
        const data = await fetchPage(1);
        totalFound = data.found || 0;
        const docs = data.hits?.map((h) => h.document) || [];
        renderedCount = docs.length;

        renderCards(docs, false);
        updatePagination();
        updateResultsPanel();

        if (scroll) scrollToSection();

        if (!filtersBuilt) {
          await fetchAllForFilters();
          filtersBuilt = true;
        }
      } catch (err) {
        console.error("Load failed:", err);
        cardsContainer.innerHTML = `<p class="w-full text-center py-12 text-red-600">Could not load awards. Please try again.</p>`;
      } finally {
        isLoading = false;
      }
    }

    async function loadMore() {
      if (isLoading) return;
      isLoading = true;
      loadMoreBtn.textContent = "Loading...";
      loadMoreBtn.disabled = true;

      try {
        currentPage++;
        const data = await fetchPage(currentPage);
        const docs = data.hits?.map((h) => h.document) || [];
        renderedCount += docs.length;
        renderCards(docs, true);
        updatePagination();
      } catch (err) {
        console.error("Load more failed:", err);
        currentPage--;
      } finally {
        loadMoreBtn.textContent = "Load More";
        loadMoreBtn.disabled = false;
        isLoading = false;
      }
    }

    async function showLess() {
      await loadFresh();
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    function scrollToSection() {
      if (!section) return;
      const offset = window.innerWidth < 1024 ? 40 : 60;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    function updateSelectedText(spanId, activeSet, defaultText, nameMap) {
      const span = document.getElementById(spanId);
      if (!span) return;
      if (activeSet.size === 0) {
        span.textContent = defaultText;
      } else {
        const names = [...activeSet].map((slug) => nameMap?.get(slug) || slug);
        span.textContent = names.join(", ");
      }
    }

    function syncAllVisuals() {
      document
        .querySelectorAll("#ma-award-type-filters [data-slug]")
        .forEach((btn) => {
          const active = activeAwardTypes.has(btn.dataset.slug);
          const box = btn.querySelector(".checkbox-box");
          const checkmark = btn.querySelector(".checkmark");
          box.classList.toggle("bg-brand-dark-red", active);
          box.classList.toggle("border-brand-dark-red", active);
          box.classList.toggle("bg-white", !active);
          box.classList.toggle("border-brand-warm-gray", !active);
          checkmark.classList.toggle("hidden", !active);
        });

      document
        .querySelectorAll("#ma-eligibility-filters [data-slug]")
        .forEach((btn) => {
          const active = activeEligibility.has(btn.dataset.slug);
          const box = btn.querySelector(".checkbox-box");
          const checkmark = btn.querySelector(".checkmark");
          box.classList.toggle("bg-brand-dark-red", active);
          box.classList.toggle("border-brand-dark-red", active);
          box.classList.toggle("bg-white", !active);
          box.classList.toggle("border-brand-warm-gray", !active);
          checkmark.classList.toggle("hidden", !active);
        });

      updateResultsPanel();
    }

    function buildCheckbox(slug, name, activeSet, onChange) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.dataset.slug = slug;
      btn.className = "w-full flex items-center justify-start gap-3";

      const isActive = activeSet.has(slug);
      btn.innerHTML = `
        <div class="checkbox-box w-6 h-6 shrink-0 border ${isActive ? "bg-brand-dark-red border-brand-dark-red" : "border-brand-warm-gray bg-white"} rounded flex items-center justify-center transition-colors">
          <svg class="checkmark ${isActive ? "" : "hidden"} w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <p class="text-p1 text-brand-black font-normal !my-0 text-start">${name}</p>
      `;

      btn.addEventListener("click", () => {
        if (activeSet.has(slug)) {
          activeSet.delete(slug);
        } else {
          activeSet.add(slug);
        }
        syncAllVisuals();
        onChange();
      });

      return btn;
    }

    async function fetchAllForFilters() {
      try {
        const url =
          `${BASE_URL}/collections/${COLLECTION}/documents/search?` +
          new URLSearchParams({
            q: "*",
            query_by: "title",
            per_page: 250,
            page: 1,
          });

        const res = await fetch(url, {
          headers: {
            "X-TYPESENSE-API-KEY": API_KEY,
          },
        });
        const data = await res.json();
        const docs = data.hits?.map((h) => h.document) || [];

        docs.forEach((doc) => {
          doc.award_type_names?.forEach((name, i) => {
            const slug = doc.award_type_slugs?.[i] || "";
            if (slug) awardTypeMap.set(slug, name);
          });
          doc.eligibility_names?.forEach((name, i) => {
            const slug = doc.eligibility_slugs?.[i] || "";
            if (slug) eligibilityMap.set(slug, name);
          });
        });

        const awardSection = document.getElementById("ma-award-type-section");
        if (awardTypeMap.size > 0) {
          awardSection.classList.remove("hidden");
          const awardFilters = document.getElementById("ma-award-type-filters");
          awardTypeMap.forEach((name, slug) => {
            awardFilters.appendChild(
              buildCheckbox(slug, name, activeAwardTypes, triggerFilter),
            );
          });
        }

        const eligibilitySection = document.getElementById(
          "ma-eligibility-section",
        );
        if (eligibilityMap.size > 0) {
          eligibilitySection.classList.remove("hidden");
          const eligibilityFilters = document.getElementById(
            "ma-eligibility-filters",
          );
          eligibilityMap.forEach((name, slug) => {
            eligibilityFilters.appendChild(
              buildCheckbox(slug, name, activeEligibility, triggerFilter),
            );
          });
        }

        syncAllVisuals();
      } catch (err) {
        console.error("Filter build failed:", err);
      }
    }

    // Fix — call updateURL() before loadFresh():
    function triggerFilter() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        updateURL();
        loadFresh(true);
      }, 300);
    }

    searchInput?.addEventListener("input", (e) => {
      searchQuery = e.target.value.trim();
      updateResultsPanel();
      triggerFilter();
    });

    loadMoreBtn.addEventListener("click", loadMore);
    showLessBtn.addEventListener("click", showLess);

    const initialParams = getURLParams();
    searchQuery = initialParams.q;
    if (searchInput) searchInput.value = initialParams.q;
    initialParams.types.forEach((slug) => activeAwardTypes.add(slug));
    initialParams.elig.forEach((slug) => activeEligibility.add(slug));

    await loadFresh();
  })();
}
